import { useNavigate } from 'react-router-dom';
import { Tabs } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from '../../settings.constants';
import { Datev } from '../datev';

import { PAYROLL_ACCOUNTING_TABS } from './payroll-accounting-setting.constants';

import { MainContainer, TabContentWrapper } from './payroll-accounting-setting.styles';

const PayrollAccountingSetting = () => {
  const navigate = useNavigate();
  const query = useRouteQuery();
  const activeKey: string = query.get('tab') || PAYROLL_ACCOUNTING_TABS.datev;

  const tabs = [
    {
      tab: 'DATEV',
      tabIndex: PAYROLL_ACCOUNTING_TABS.datev,
      component: <Datev />,
    },
  ];

  const onTabChange = (tab: string) =>
    navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.payrollAccounting}&tab=${tab}`);

  return (
    <MainContainer>
      <Tabs
        onChange={onTabChange}
        defaultActiveKey={PAYROLL_ACCOUNTING_TABS.datev}
        destroyInactiveTabPane
        activeKey={activeKey}
      >
        {tabs.map(item => (
          <Tabs.TabPane key={item.tabIndex} tab={item.tab}>
            <TabContentWrapper>{item.component}</TabContentWrapper>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </MainContainer>
  );
};

export default PayrollAccountingSetting;
